export default __webpack_public_path__ + "content/media/15.db1bc23c.jpg";